import { createSlice } from '@reduxjs/toolkit';

const initialState = {open:false};
const slice = createSlice({
    name: 'notification/modal',
    initialState,
    reducers: {
        toggle:(state)=>{
            return {open:!state.open};
        },
        modalOpen: (state) => {
            state.open = true;
        },
        modalClose: (state) => {
            state.open = false;
        }
    }
});

export default slice.reducer;
export const notificationModalActions = slice.actions;

export function toggleNotification(){
    return function(dispatch){
        dispatch( notificationModalActions.toggle() );
    }
}

export function openNotification(){
    return function(dispatch){
        dispatch( notificationModalActions.modalOpen() );
    }
}

export function closeNotification(){
    return function(dispatch){
        dispatch( notificationModalActions.modalClose() );
    }
}